import { createGlobalStyle } from 'styled-components';

import kor from "../assets/fonts/NotoSansKR-VariableFont_wght.ttf";
import eng from "../assets/fonts/Oxanium-VariableFont_wght.ttf";
import title from "../assets/fonts/Wemakeprice-Regular.ttf";

import reset from "styled-reset";

const GlobalStyle = createGlobalStyle`
  ${reset};

  @font-face {
    font-family: "TbellFont";
    src: url(${kor}) format('truetype');
    font-style: normal;
  }

  @font-face {
    font-family: "TbellFont";
    src: url(${kor}) format('truetype'); 
    font-style: normal;
    unicode-range: U+0041-005A, U+0061-007A, U+0030-0039;
  }

  @font-face {
    font-family: "NumFont";
    src: url(${eng}) format('truetype'); 
    font-style: normal;
    unicode-range: U+0041-005A, U+0061-007A, U+0030-0039;
  }

  @font-face {
    font-family: "TitleFont";
    src: url(${kor}) format('truetype');
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family: "ContentFont";
    src: url(${kor}) format('truetype');
    font-style: normal;
    font-weight: 200;
  }

  * {
    font-family: "TbellFont";
    color: #ffffff;
    line-height: 1.5;
  }

  h1 {
    font-family: "TitleFont";
  }
  
  h2, h3 {
    font-family: "ContentFont";
  }
`;

export default GlobalStyle;

// noto sans kr - light 300 regular 400 bold 700
// oxanium - light 300 regular 400 bold 700

// #27C4D5
// #2EA090